module.exports = __webpack_public_path__ + "img/menu-icon-contact-us-circle.8f0f0274.svg";